import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CurrentLocale, LocaleCurrency } from '../data/model/currencylocale';

@Injectable({
  providedIn: 'root'
})
export class CurrencyLocaleService {
  currentLocale: CurrentLocale
  localeCurrency: Subject<LocaleCurrency> = new BehaviorSubject(null);

  baseurl = environment.baseUrl;

  constructor(private http: HttpClient) {
   
   }


    // Get Locale and Currency
    getLocaleCurrency(): Observable<LocaleCurrency> {
      return this.localeCurrency;
    }
    setLocaleCurrency() {
      this.http.get<any>('https://ipapi.co/json').subscribe({
        next: res=>{
          this.currentLocale = res;
          this.setCurrency()
        },error:()=>{
          let  currency = new LocaleCurrency()
           this.localeCurrency.next(currency)
        }
      })
  }
  setCurrency(){
           let  currency = new LocaleCurrency()
           currency.ip = this.currentLocale.ip
           this.localeCurrency.next(currency)
           return // Disable currency internationalization
    if(!this.currentLocale || this.currentLocale.currency == 'NGN'){
     let  currency = new LocaleCurrency()
     currency.ip = this.currentLocale.ip
     //currency.to_currency = '&#8358;'
      this.localeCurrency.next(currency)
    }else{
      this.http.get<any>(`${this.baseurl}/rate/find/NGN/USD`).subscribe({
        next:res=>{
          //res.data.to_currency = "&#x24;"
          if(res.data){
            res.data.ip = this.currentLocale.ip
            this.localeCurrency.next(res.data)
          }else{
            let  currency = new LocaleCurrency()
            currency.ip = this.currentLocale.ip
             this.localeCurrency.next(currency)
          }
          
        },error:()=>{
          this.localeCurrency.next(new LocaleCurrency())
        }
      })
    }
  }
}

